<template>
  <v-card outlined class="white" :elevation="5">
    <v-chart
      :option="polar"
      autoresize
      :style="{ height: '300px', width: '100%' }"
      @click="viewConver"
    />
  </v-card>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart } from 'echarts/charts'
import { LegendComponent } from 'echarts/components'

import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  VisualMapComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

import moment from 'moment'
import variables from '@/styles/variables.scss'

use([
  LegendComponent,
  CanvasRenderer,
  BarChart,
  LineChart,
  GridComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent
])
export default {
  components: {
    VChart
  },
  props: {
    color: Array,
    title: String,
    xAxis: Array,
    data: Array,
    direction: String,
    filterFrom: String,
    filterTo: String,
    filterType: String,
    filterViewGroup: String
  },
  watch: {
    xAxis: {
      handler(newOptionValue) {
        this.chart()
      }
    }
  },
  created() {
    this.chart()
  },
  data() {
    return {
      polar: {}
    }
  },
  methods: {
    chart() {
      let legends = []
      let series = []
      for (let i = 0; i < this.data.length; i++) {
        const data = this.data[i]
        data.stack = this.title
        data.label = {
          show: true,
          formatter: params => {
            return `${params.value.toLocaleString()}`
          }
        }
        legends.push(data.name)
        series.push(data)
      }
      this.polar = {
        textStyle: {
          fontFamily: variables.fontFamily
        },
        color: this.color,
        title: {
          text: this.title,
          left: '20',
          top: '10px'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            let text = `${params[0].name} <br />`

            let detail = ''
            let total = 0
            for (let i = 0; i < params.length; i++) {
              let value = 0

              if (params[i].value !== '-') {
                if (params[i].seriesName.includes('%'))
                  value = `${params[i].value}%`
                else {
                  value = params[i].value.toLocaleString()
                  total += params[i].value
                }
              }

              detail += `<ul><li class="li1">${params[i].marker} ${params[i].seriesName}</li> <li class="li2">${value}</li></ul>`
            }

            text +=
              `<ul><li class="li1">Total</li> <li class="li2">${total}</li></ul>` +
              detail
            return text
          }
        },
        legend: {
          data: legends,
          left: 'center',
          bottom: '5px'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.xAxis
        },
        yAxis: {
          type: 'value'
        },
        series
      }
    },
    viewConver(query) {
      let from
      let to
      if (this.filterViewGroup === 'month') {
        const convert = moment(query.name, 'MMM YYYY').startOf('month')

        from = `${convert.format('YYYY-MM-DD')} 00:00`
        to = `${moment(convert)
          .add(1, 'months')
          .format('YYYY-MM-DD')} 00:00`

        const fromMonth = moment(this.filterFrom, 'YYYY-MM-DD HH:mm').format(
          'YYYYMM'
        )
        const toMonth = moment(this.filterTo, 'YYYY-MM-DD HH:mm').format(
          'YYYYMM'
        )
        const selectMonth = convert.format('YYYYMM')

        if (fromMonth === toMonth) {
          from = this.filterFrom
          to = this.filterTo
        } else if (fromMonth === selectMonth) {
          from = this.filterFrom
          to = `${moment(convert)
            .add(1, 'months')
            .format('YYYY-MM-DD')} 00:00`
        } else if (toMonth === selectMonth) {
          from = `${convert.format('YYYY-MM-DD')} 00:00`
          to = this.filterTo
        }
      } else {
        from = `${moment(query.name).format('YYYY-MM-DD')} 00:00`
        to = `${moment(query.name)
          .add(1, 'days')
          .format('YYYY-MM-DD')} 00:00`
      }

      const type = this.filterType
      const group = query.seriesName.replace(/ /g, '-').toLowerCase()
      const routeData = this.$router.resolve({
        path: `/conversations?from=${from}&to=${to}&direction=${this.direction}&type=${type}&group=${group}`
      })

      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep ul {
  list-style: none;
}
::v-deep .li1 {
  display: inline-block;
  width: 200px;
  text-align: left;
}
::v-deep .li2 {
  display: inline-block;
  width: 70px;
  text-align: left;
}
</style>
